import React, { useEffect } from 'react';
import { BaseDialog } from 'src/components/common';
import { useFetch } from 'src/utils/hooks/useFetch';
import { GuestApi } from 'src/api/base/Guest';
import { FullSizeProgress } from 'src/routing/RouteSuspense';
import { ContactOverview } from '../ContactOverview';

type POverviewGuestModal = {
  open: boolean;
  onClose: () => void;
  guestId: number;
};

export const OverviewGuestModal: React.FC<POverviewGuestModal> = (props) => {
  const { open, onClose, guestId } = props;

  const [{ response, isLoading }, doFetch] = useFetch<any, any>(
    GuestApi.getGuest,
  );

  useEffect(() => {
    doFetch(guestId);
  }, [guestId, doFetch]);

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title="Guest Details"
      paperStyles={{ maxWidth: '900px', width: '100%' }}
    >
      {isLoading ? (
        <FullSizeProgress />
      ) : (
        <ContactOverview guest={response?.data?.data} />
      )}
    </BaseDialog>
  );
};
